import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Markdown from '../markdown';
import { registerWidget } from './sections';
import quoteStyles from './quote.styles';

/**
 * @param {Object} props
 * @param {String} props.className
 * @param {String} props.quote Markdown
 * @param {Object} props.person Contentful fields
 */
const Quote = ({
  className,
  quote,
  person,
}) => (
  <div className={`Quote ${className}`}>
    <div className='person'>
      <img
        src={get(person, 'fields.photo[0].fields.file.url')}
        alt={get(person, 'fields.name')}
      />
    </div>
    <div className='quoteText'>
      <Markdown source={`${quote}`} />
      <div className='name'>
        &nbsp;
        &mdash;
        &nbsp;
        {`${get(person, 'fields.name')}, ${get(person, 'fields.title')}`}
      </div>
    </div>
  </div>
);

Quote.propTypes = {
  /**
   * This expects a Contentful shape, legacy.
   * To-do: Move this to own folder and create widget to separate
   * Contentful from UI
   * */
  person: PropTypes.shape({}).isRequired,
  /**
   * Markdown string
   */
  quote: PropTypes.string.isRequired,
  className: PropTypes.string,
};

Quote.defaultProps = {
  className: '',
};

const StyledQuote = styled(Quote)`
${quoteStyles}
`

registerWidget('quote', StyledQuote);

export default StyledQuote;
